import React from 'react';
import withSuggestionBox from './withSuggestionBox';

function MostRead({ data }) {
  return <>{data}</>;
}
export default withSuggestionBox(MostRead);
